export default class TranslationManager {
  constructor(lang) {
    this.lang = lang;
    this._experiment = document.querySelector(".pre-title");
    this._title = document.querySelector(".title");
    // this._subtitle = document
    //   .querySelector(".subtitle")
    //   .getElementsByTagName("span")[0];
    try {
      const levels = document
        .getElementById("choice")
        .getElementsByClassName("mdc-chip__text");
      this._easy = levels[0];
      this._medium = levels[1];
      this._difficult = levels[2];
      // tooltips
      this._saving = document.querySelector(".savetiped");
      // const tooltips = document.getElementsByClassName("tooltiped");
      // console.log(tooltips);
      this._back = document.getElementsByClassName("home")[0];
      this._group = document.getElementById("groupNavigation");
      this._zoomIn = document.getElementsByClassName("zoomIn")[0];
      this._zoomOut = document.getElementsByClassName("zoomOut")[0];
      this._background = document.getElementsByClassName("lightmode")[0];
      this._preview = document.getElementsByClassName("photo")[0];
      this._invite = document.getElementsByClassName("share_nav")[0];
      //player
      this._player = document.getElementById("playerAmount");
      //your puzzle
      this._puzzleHeader = document.getElementById("my-dialog-title-sharing");

      const popup = document.querySelector(".sharing");
      //   learn more on popup
      this._learnMorePopUp = popup
        .getElementsByClassName("learnMoreButton")[0]
        .getElementsByClassName("mdc-button__label")[0];

      // new puzzle button
      this._newPuzzle = popup
        .getElementsByClassName("restartButton")[0]
        .getElementsByClassName("mdc-button__label")[0];

      //   SOLO
      this._solo = popup
        .getElementsByClassName("soloButton")[0]
        .getElementsByClassName("mdc-button__label")[0];
      //  MULTI PLAYER
      this._multiplayer = popup
        .getElementsByClassName("shareButton")[0]
        .getElementsByClassName("mdc-button__label")[0];
    } catch (error) {
      /** silent fail */
    }
  }

  init() {
    return new Promise((resolve, reject) => {
      // const url =
      //   "https://cilex-puzzle.appspot.com.storage.googleapis.com/translations/";
      const url =
        "https://storage.googleapis.com/cilex-puzzle-newregion/cilex-puzzle.appspot.com/translations/";
      fetch(url + this.lang + ".json")
        .then((data) => data.json())
        .then((json) => {
          this.data = json;
          console.log("translation data ready");
          resolve();
        });
    });
  }

  update() {
    // learn more on preview
    this._learnMore = document
      .querySelector(".draggableModal")
      .getElementsByClassName("learnMoreButton")[0]
      .getElementsByClassName("mdc-button__label")[0];
  }

  get(param) {
    return this.data[param];
  }

  set(param) {
    console.log(param);
  }

  setDefault() {
    try {
      this._experiment.textContent = this.data["experiment"];
      this._title.textContent = this.data["puzzle_party"];
      this._easy.textContent = this.data["easy"];
      this._medium.textContent = this.data["medium"];
      this._difficult.textContent = this.data["difficult"];
      this._saving.setAttribute("data-savetip", this.data["saving"] + "...");
      this._back.setAttribute("data-tooltip", this.data["back"]);
      this._group.setAttribute("data-tooltip", this.data["group"]);
      this._zoomIn.setAttribute("data-tooltip", this.data["zoom_in"]);
      this._zoomOut.setAttribute("data-tooltip", this.data["zoom_out"]);
      this._background.setAttribute("data-tooltip", this.data["background"]);
      this._preview.setAttribute("data-tooltip", this.data["preview"]);
      this._invite.setAttribute("data-tooltip", this.data["invite"]);
      this._player.textContent = this.data["player"];
      this._learnMorePopUp.textContent = this.data["learn_more"];
      this._newPuzzle.textContent = this.data["new_puzzle"];
      this._solo.textContent = this.data["solo"];
      this._multiplayer.textContent = this.data["multiplayer"];
      this._puzzleHeader.textContent = this.data["your_puzzle"];
    } catch (error) {
      /** silent fail */
    }
  }
}
